const SakuraBranch = ({ className = "" }) => (
  <svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={className}>
    <path d="M4 96C4 96 24 60 40 40C56 20 76 4 76 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="52" cy="26" r="6" fill="currentColor" opacity="0.85" />
    <circle cx="64" cy="14" r="5" fill="currentColor" opacity="0.7" />
    <circle cx="38" cy="46" r="5" fill="currentColor" opacity="0.8" />
    <circle cx="26" cy="62" r="4" fill="currentColor" opacity="0.6" />
    <circle cx="60" cy="24" r="2" fill="currentColor" opacity="0.9" />
  </svg>
);

export default SakuraBranch;
